import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AdminLayoutRoutes } from '../layouts/admin-layout/admin-layout.routing';
import {NgxPaginationModule} from 'ngx-pagination';
import { AvatarModule } from 'ngx-avatar';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';

import { DispatucherRestaurantComponent } from './dispatucher-restaurant/dispatucher-restaurant.component';
import { RestaurantRoutingModule } from './restaurant.routing';
import { RestaurentsInfoComponent } from './restaurents-info/restaurents-info.component';
import { AddRestaurantComponent } from './add-restaurant/add-restaurant.component';
import { UpdateRestaurantComponent } from './update-restaurant/update-restaurant.component';
import { AboutComponent } from './restaurents-info/about/about.component';
import { SettingComponent } from './restaurents-info/setting/setting.component';
import { PhotosComponent } from './restaurents-info/photos/photos.component';
import { MenuComponent } from './restaurents-info/menu/menu.component';
import { OrdersComponent } from './restaurents-info/orders/orders.component';
import {MatSortModule} from '@angular/material/sort';
import {MatTableModule} from '@angular/material/table';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatSliderModule } from '@angular/material/slider';
import { SelectAutocompleteModule } from 'mat-select-autocomplete';
import {MatButtonModule, MatCheckboxModule} from '@angular/material';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SelectDropDownModule } from 'ngx-select-dropdown'

@NgModule({
  declarations: [
    DispatucherRestaurantComponent,
    RestaurentsInfoComponent,
    AddRestaurantComponent,
    UpdateRestaurantComponent,
    AboutComponent,
    SettingComponent,
    PhotosComponent,
    MenuComponent,
    OrdersComponent,
  ],
  imports: [
    CommonModule,
    RestaurantRoutingModule,
    NgxPaginationModule,
    AvatarModule,
    FormsModule,
    ReactiveFormsModule,
    MatSortModule,
    MatTableModule,
    Ng2SearchPipeModule,
    MatSliderModule,
    SelectAutocompleteModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatSelectModule,
    NgMultiSelectDropDownModule.forRoot(),
    SelectDropDownModule

    ]
})
export class RestaurantModule { }
